import { Link } from '@tanstack/react-router'
import { Icon } from '../components/icons/Icon.jsx'
import { UserMenu } from '../components/ui/UserMenu.jsx'
import { useMe } from '../lib/queries/session.js'
import p from './pages.module.css'

/** DCKAP Hub landing page after sign-in: one block per app. */
export function HubPage() {
  const { user } = useMe()
  const firstName = user?.name?.split(' ')[0]

  return (
    <main className={p.hub}>
      <header className={p.hubHead}>
        <span className={p.hubBrand}>
          <span className={p.hubMark}>
            <Icon name="logo" size={18} strokeWidth={1.7} />
          </span>
          DCKAP Hub
        </span>
        <div className={p.hubUser}>
          <UserMenu side="bottom" align="end" />
        </div>
      </header>

      <div className={p.hubBody}>
        <h1 className={p.hubTitle}>{firstName ? `Welcome, ${firstName}` : 'Welcome'}</h1>
        <p className={p.hubLead}>Choose where you want to work.</p>

        <div className={p.hubGrid}>
          <Link to="/new" className={p.hubCard}>
            <span className={p.hubIcon}>
              <Icon name="layers" size={22} strokeWidth={1.6} />
            </span>
            <span className={p.hubCardTitle}>Knowledge Base</span>
            <span className={p.hubCardText}>
              Ask about any integrated system — endpoints, field maps and how systems connect — and manage the System
              library.
            </span>
            <span className={p.hubCardAction}>
              Open
              <Icon name="arrow-right" size={14} strokeWidth={1.7} />
            </span>
          </Link>

          <Link to="/projects" className={p.hubCard}>
            <span className={p.hubIcon}>
              <Icon name="sliders" size={22} strokeWidth={1.6} />
            </span>
            <span className={p.hubCardTitle}>Project Management</span>
            <span className={p.hubCardText}>
              Track each integration project: the systems in scope, the credentials we still need from the client and
              the weekly calls, with Sybill for call notes.
            </span>
            <span className={p.hubCardAction}>
              Open
              <Icon name="arrow-right" size={14} strokeWidth={1.7} />
            </span>
          </Link>

          <Link to="/support" className={p.hubCard}>
            <span className={p.hubIcon}>
              <Icon name="ticket" size={22} strokeWidth={1.6} />
            </span>
            <span className={p.hubCardTitle}>Support</span>
            <span className={p.hubCardText}>
              Work customer tickets: see what the customer has given and what is missing, draft a professional reply and
              keep the answer in the support knowledge base.
            </span>
            <span className={p.hubCardAction}>
              Open
              <Icon name="arrow-right" size={14} strokeWidth={1.7} />
            </span>
          </Link>
        </div>
      </div>
    </main>
  )
}
